import React from 'react'

import Window from '../Window'

import { acceptSiteMessage } from '../../../API/generalAPI'

const SiteNotification = ({ siteNotify, close }) => {
  const handleClick = () => {
    acceptSiteMessage({
      ttRequest: [{ mode: 'accept', siteMsgId: siteNotify.id }],
    })
      .then(() => {})
      .catch((error) => {})
      .then(() => {
        close()
      })
  }

  return (
    <Window
      width={'md'}
      open={siteNotify ? true : false}
      close={close}
      title={siteNotify ? siteNotify.title : 'Site Notification'}
      primary={'I Accept'}
      handlePrimary={handleClick}
      error={'Cancel'}
      handleError={close}
    >
      <div>{siteNotify ? siteNotify.body : 'Notify'}</div>
    </Window>
  )
}

export default SiteNotification
